<ms-error *ngIf="!sports || sports.length === 0; else listTemplate" [message]="sitecore.event.ErrNoEvents" [severity]="'info'"></ms-error>
<ng-template #listTemplate>
    <div class="list list-card row">
        <ms-item
            class="col-12 col-sm-6"
            *ngFor="let sport of sports"
            [title]="sport.title"
            [count]="sport.count"
            [href]="sport.url"
            [icon]="sport.icon ?? 'sports-' + sport.id">
        </ms-item>
    </div>
</ng-template>
